"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPuzzleObservable = void 0;
const rxjs_1 = require("rxjs");
const blockwise_1 = require("blockwise");
const _1 = require(".");
function createPuzzleObservable(context) {
    const _puzzle$ = new rxjs_1.Subject();
    let puzzle = context.initialPuzzle;
    const puzzleHistory = new _1.PuzzleHistory(puzzle);
    _puzzle$.subscribe(p => puzzleHistory.append(p));
    context.backClicks$.subscribe(function () {
        const last = puzzleHistory.rewind();
        if (last) {
            puzzle = last;
            _puzzle$.next(last);
        }
    });
    context.mouseClicks$.subscribe(function (position) {
        const bit = puzzle.bits.find(function (b) {
            return (0, blockwise_1.isBlockIncluding)(b.block, position);
        });
        if (bit && !puzzle.candidate) {
            puzzle = {
                ...puzzle,
                candidate: { ...bit }
            };
            _puzzle$.next(puzzle);
        }
    });
    context.mouseClicks$.subscribe(function (position) {
        const clickingLatch = (0, blockwise_1.isBlockIncluding)(puzzle.latch.block, position);
        if (clickingLatch) {
            puzzle = {
                ...puzzle,
                latchIsMoved: true
            };
            _puzzle$.next(puzzle);
        }
    });
    context.mouseUps$.subscribe(function () {
        if (puzzle.candidate === undefined) {
            return;
        }
        const candidate = puzzle.candidate;
        puzzle = {
            ...puzzle,
            bits: puzzle.bits.map(function (b) {
                return {
                    ...b.id === candidate.id
                        ? candidate
                        : b
                };
            }),
            candidate: undefined,
            moveCount: puzzle.moveCount + 1
        };
        _puzzle$.next(puzzle);
    });
    context.mouseUps$.subscribe(function () {
        if (puzzle.latchIsMoved) {
            puzzle = {
                ...puzzle,
                latchIsMoved: false,
                moveCount: puzzle.moveCount + 1
            };
            _puzzle$.next(puzzle);
        }
    });
    context.mousePosition$.pipe((0, blockwise_1.mapPositionsToUnitaryMovements)(), (0, rxjs_1.mergeWith)(context.playgroundTouch$.pipe((0, _1.mapPlaygroundTouchesToBitMoves)(_1.blockPixelSize)))).subscribe(function (position) {
        if (puzzle.candidate === undefined) {
            return;
        }
        const candidate = puzzle.candidate;
        const newCandidate = {
            ...candidate,
            block: {
                ...candidate.block,
                x: candidate.block.x + position.x,
                y: candidate.block.y + position.y
            }
        };
        const bitMoveLegal = (0, _1.isBitMoveLegal)(puzzle, newCandidate);
        if (bitMoveLegal) {
            puzzle = {
                ...puzzle,
                candidate: newCandidate
            };
            _puzzle$.next(puzzle);
        }
    });
    context.mousePosition$.pipe((0, blockwise_1.mapPositionsToUnitaryMovements)(), (0, rxjs_1.mergeWith)(context.playgroundTouch$.pipe((0, _1.mapPlaygroundTouchesToBitMoves)(_1.blockPixelSize)))).subscribe(function (position) {
        if (!puzzle.latchIsMoved) {
            return;
        }
        const newLatchBlock = {
            ...puzzle.latch.block,
            x: puzzle.latch.block.x + position.x
        };
        const latchMoveLegal = (0, _1.isLatchMoveLegal)(puzzle, newLatchBlock);
        if (latchMoveLegal) {
            puzzle = {
                ...puzzle,
                latch: {
                    ...puzzle.latch,
                    block: newLatchBlock
                }
            };
            _puzzle$.next(puzzle);
        }
    });
    return _puzzle$.asObservable();
}
exports.createPuzzleObservable = createPuzzleObservable;
